if (!customElements.get('ph-slider')) {
  customElements.define('ph-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.dots = this.querySelector('[data-slider-dots]');
      if (!this.track || !this.dots) return;
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
      this.observer = new ResizeObserver(() => this.build());
      this.observer.observe(this.track);
      this.build();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    get step() {
      const cards = this.track.children;
      if (cards.length < 2) return this.track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    build() {
      const overflow = this.maxScroll;
      const pages = overflow > 1 ? Math.ceil(overflow / this.step - 0.05) + 1 : 0;
      if (pages === this.pages) return this.update();
      this.pages = pages;
      this.dots.innerHTML = '';
      this.dots.hidden = pages < 2;
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', (this.dataset.dotLabel || 'Seite') + ' ' + (i + 1));
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: Math.min(i * this.step, this.maxScroll) });
        });
        this.dots.appendChild(dot);
      }
      this.update();
    }

    update() {
      if (!this.pages) return;
      const left = this.track.scrollLeft;
      let active = Math.round(left / this.step);
      if (left >= this.maxScroll - 2) active = this.pages - 1;
      active = Math.min(active, this.pages - 1);
      [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
    }
  });
}
